import React from 'react'
import { Head, Link } from '@inertiajs/react'
import { ArrowLeft } from 'lucide-react'
import { AdminLayout } from '@/components/admin/templates/AdminLayout'
import { Surface } from '@/components/admin/atoms/layout/Surface'
import { Stack } from '@/components/admin/atoms/layout/Stack'
import { Inline } from '@/components/admin/atoms/layout/Inline'
import { Padding } from '@/components/admin/atoms/layout/Padding'
import { Heading } from '@/components/admin/atoms/typography/Heading'
import { ActionButton } from '@/components/admin/atoms/actions/ActionButton'
import { VisitorInfoHeader } from '@/components/admin/atoms/analytics/VisitorInfoHeader'
import { VisitorTimeline } from '@/components/admin/atoms/analytics/VisitorTimeline'
import type { PageProps } from '@/types/inertia.d'
import type { VisitorJourney } from '@/types/analytics'

type Props = PageProps<{ journey: VisitorJourney }>

const AnalyticsShow: React.FC<Props> = ({ journey }) => (
  <AdminLayout
    breadcrumbs={[
      { label: 'Analytics', href: '/admin/analytics' },
      { label: `Visitor ${journey.visitor_hash.slice(0, 8)}` },
    ]}
  >
    <Head title={`Visitor ${journey.visitor_hash.slice(0, 8)}`} />
    <Stack gap="6">
      <Inline justify="between" align="center">
        <Inline gap="3" align="center">
          <Link href="/admin/analytics">
            <ActionButton variant="ghost">
              <ArrowLeft />
              Back to Analytics
            </ActionButton>
          </Link>
          <Heading level={3}>Visitor Journey</Heading>
        </Inline>
      </Inline>

      <Surface variant="card" radius="lg">
        <VisitorInfoHeader journey={journey} />
      </Surface>

      <Surface variant="card" radius="lg">
        <Padding all="5">
          <Stack gap="4">
            <Heading level={5}>
              Page Flow ({journey.events.length} {journey.events.length === 1 ? 'page' : 'pages'})
            </Heading>
            <VisitorTimeline events={journey.events} />
          </Stack>
        </Padding>
      </Surface>
    </Stack>
  </AdminLayout>
)

export default AnalyticsShow
